module.exports = __webpack_public_path__ + "static/media/Envelope.fd66f52d.png";